import './index.scss';
import 'components/percent_bar';

function HideButtonContinueModalEvent() {
  $('#js-hide-continue-modal').on('click', function(e) {
    e.preventDefault();

    if (!localStorage) {
      return;
    }
    localStorage.setItem('continueModalHide', true);
    $('#continue-modal-dont-show').prop('checked', false);

    window.UserTracker.emit('event', {
      eventName: 'modal continue occulted'
    });
  });

  $('#js-continue-modal').on('shown.bs.modal', function() {

    window.UserTracker.emit('event', {
      eventName: 'modal continue viewed'
    });
  });

  $('.q-suggestion-name').on('click', function() {
    window.UserTracker.emit('event', {
      eventName: 'modal continue clicked',
      data: {
        suggestion: $(this).data('optionType')
      }
    });
  });
}

export default HideButtonContinueModalEvent;
